import React from "react";
import PropTypes from "prop-types";
import {AEmptyState} from "@cisco-sbg-ui/magna-react";
import {useTranslation} from "react-i18next";
import EmptyContent from "../EmptyContent";

/**
 * Component to render in place of a data table when there are no data to render in that table. Ensures consistent English wording.
 *
 * @param {string} entityNamePlural plural name of the entities that will get lower-cased and interpolated into the message shown, if needed.
 * @param {boolean} hasFiltersApplied 'true' if the table of entities is filtered, or 'false' if the table is empty because the customer has no such data in their account
 * @return {JSX.Element}
 * @constructor
 */
export default function TableEmptyState({
  entityNamePlural,
  hasFiltersApplied = false
}) {
  const {t} = useTranslation();

  return (
    <div style={{margin: "32px 0 4px"}}>
      {hasFiltersApplied ? (
        <AEmptyState
          medium
          message={t("table.label.noMatchingResults")}
          variant="positive"
        />
      ) : (
        <EmptyContent>
          {t("table.label.noResultsFound", {
            name: entityNamePlural.toLowerCase()
          })}
        </EmptyContent>
      )}
    </div>
  );
}

TableEmptyState.propTypes = {
  entityNamePlural: PropTypes.string.isRequired,
  hasFiltersApplied: PropTypes.bool
};
